import { FC, useMemo } from 'react'
import cn from 'classnames'
import { AdvisorUid } from 'components/features/coaching/advisor/types/advisor'
import { createAdvisorSelector } from 'components/features/coaching/advisorMeeting/selectors/advisorsSelector'
import { useStoreSelector } from 'helpers/reactReduxHelpers'
import SvgIcon from 'components/atoms/SvgIcon'
import AdvisorSvg from 'icons/coaching.svg'
import AdjustableImage from 'components/features/pfm/AdjustableImage/AdjustableImage'
import styles from 'components/features/coaching/advisor/AdvisorAvatar/AdvisorAvatar.styl'

type AdvisorAvatarProps = {
  uid: AdvisorUid
  type?: 'regular' | 'auxBorderWidth'
}
export const AdvisorAvatar: FC<AdvisorAvatarProps> = (props) => {
  const { type } = props
  const advisorSelector = useMemo(createAdvisorSelector, [])
  const advisor = useStoreSelector((state) => advisorSelector(state, props))

  const avatar = advisor?.profile_picture ?? null
  const hasImage = !!(avatar && avatar.sources)

  return (
    <AdvisorAvatarDecoration hasImage={ hasImage } type={ type }>
      { !hasImage && (
        <SvgIcon src={ AdvisorSvg } />
      )}
      { hasImage && (
        <AdjustableImage
          preventLazyRender
          image={ avatar }
          fitToContainer
        />
      )}
    </AdvisorAvatarDecoration>
  )
}

type AdvisorAvatarDecorationProps =
  & Pick<AdvisorAvatarProps, 'type'>
  & {
    hasImage: boolean
  }

const AdvisorAvatarDecoration: FC<AdvisorAvatarDecorationProps> = (props) => {
  const { children, hasImage, type = 'regular' } = props

  return (
    <div className={ cn(styles.advisorAvatar, styles[type]) }>
      <div className={ styles.layer1 }>
        <div className={ cn(styles.layer2, hasImage && styles.hasImage) }>
          { children }
        </div>
      </div>
    </div>
  )
}
